<template>
    <div>
        <table v-if="!isMobile" class="table">
            <tr class="marker-row">
                <td colspan="1"></td>
                <template v-for="(marker, index) in this.tabs">
                    <td v-if="!marker.matrix_column_marker" :key="'marker-' + index"></td>
                    <td class="column-marker" v-if="marker.matrix_column_marker" :key="'marker-' + index">
                        {{ marker.matrix_column_marker }}
                    </td>
                </template>
            </tr>
            <tr class="tabs-row">
                <td colspan="1"></td>
                <th class="tab" :style="`tab-${index}`" v-for="(tab, index) in this.tabs" :key="'title-' + index">
                    <span>{{ tab.matrix_column_title }}</span>
                    <p>{{ tab.matrix_column_subtitle }}</p>
                </th>
            </tr>
            <template v-for="(row, rowIndex) in this.rows">
                <tr class="category-header" v-if="row.type === rowType.CATEGORY_HEADER"
                    :key="'category-header-' + rowIndex">
                    <td class="category-header-title" v-html="row.non_repeat.matrix_feature_category_name"></td>
                    <td :colspan="tabs.length"></td>
                </tr>
                <tr class="feature" v-if="row.type === rowType.FEATURE" :key="'feature-' + rowIndex">
                    <td class="feature-title" v-html="row.non_repeat.matrix_row_title"></td>
                    <template v-for="(cell, cellIndex) in row.repeat">
                        <td :colspan="row.repeat.length === 1 ? tabs.length : 1" class="cell-text"
                            v-if="cell.matrix_cell_type === cellType.TEXT" v-html="cell.matrix_cell_text"
                            :key="'cell-text-' + cellIndex"></td>
                        <td :colspan="row.repeat.length === 1 ? tabs.length : 1"
                            v-if="cell.matrix_cell_type === cellType.ICON" :key="'cell-icon-' + cellIndex">
                            <img id="check-icon" :src="`/images/feather-icons/${featherIconMap.get(cell.matrix_cell_icon)}.svg`">
                        </td>
                    </template>
                </tr>
            </template>
        </table>
        <div v-else>
            <v-collapse-wrapper
                :active="index === 1"
                class="tab"
                :class="[tab.matrix_column_marker ? 'marker' : '']"
                :style="`tab-${index}`"
                v-for="(tab, index) in this.tabs"
                :key="`tab-${index}`"
                v-on:onStatusChange="collapseHandler">
                <div class="marker-mobile" v-if="tab.matrix_column_marker">{{ tab.matrix_column_marker }}</div>
                <span>{{ tab.matrix_column_title }}</span>
                <p>{{ tab.matrix_column_subtitle }}</p>
                <div class="information-button" v-collapse-toggle>
                    <p>{{ lang.information }}</p>
                    <img class="minus-circle" :src="`/images/feather-icons/minus-circle-white.svg`">
                    <img class="plus-circle" :src="`/images/feather-icons/plus-circle.svg`">
                </div>
                <div v-collapse-content class="collapse-content-container">
                    <div class="categories" v-for="(category, categoryIndex) in computeCategories"
                         :key="'category-' + categoryIndex">
                        <div class="category-header">
                            <div class="category-header-title"
                                 v-html="category.non_repeat.matrix_feature_category_name"></div>
                        </div>
                        <div class="features">
                            <div class="feature" v-for="(feature, featureIndex) in category.features"
                                 :key="'category-' + featureIndex">
                                <div class="feature-title" v-html="feature.non_repeat.matrix_row_title"></div>
                                <div class="cell-text"
                                     v-if="getFeature(feature, index).matrix_cell_type === cellType.TEXT"
                                     v-html="getFeature(feature, index).matrix_cell_text"></div>
                                <div class="cell-icon"
                                     v-if="getFeature(feature, index).matrix_cell_type === cellType.ICON">
                                    <img
                                        :src="`/images/feather-icons/${featherIconMap.get(getFeature(feature, index).matrix_cell_icon)}.svg`">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-collapse-wrapper>
        </div>
    </div>
</template>

<script>
const iconType = {
    CHECK: 'check',
    UNCHECK: 'uncheck'
};
const featherIconMap = new Map();
featherIconMap.set(iconType.CHECK, 'check-circle');
featherIconMap.set(iconType.UNCHECK, 'x-circle');
export default {
    name: "FeatureMatrixTable",
    props: ['tabs', 'rows', 'lang'],

    created() {
        window.addEventListener("resize", this.resizeHandler);
        this.rowType = {
            CATEGORY_HEADER: 'category_header',
            FEATURE: 'feature'
        };
        this.cellType = {
            TEXT: 'text',
            ICON: 'icon'
        }
        this.iconType = iconType;
        this.featherIconMap = featherIconMap;
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeHandler);
    },
    data() {
        return {
            isMobile: window.matchMedia('(max-width: 767px)').matches,
        }
    },
    computed: {
        computeCategories() {
            let categories = [];
            for (const row of this.rows) {
                if (row.type === this.rowType.CATEGORY_HEADER || categories.length === 0) {
                    categories.push({non_repeat: row.non_repeat, features: []});
                } else {
                    categories[categories.length - 1].features.push({non_repeat: row.non_repeat, repeat: row.repeat});
                }
            }
            return categories;
        },
    },
    methods: {
        resizeHandler() {
            this.isMobile = window.matchMedia('(max-width: 767px)').matches;
        },
        collapseHandler(vm) {
            if (vm.status) {
                vm.vm.$el.classList.add('expanded');
            } else {
                vm.vm.$el.classList.remove('expanded');
            }
        },
        getFeature(feature, index) {
            if (feature.repeat.length === 1) {
                return feature.repeat[0];
            } else {
                return feature.repeat[index];
            }
        }
    },
}
</script>

<style scoped>


.table {
    table-layout: fixed;
    margin-top: 16px;
    border-bottom: 2px solid #E7F3EC;
}

.tab {
    background-color: #7DBB97;
    color: #FFFFFF;
    text-align: center;
    font-family: 'Qanelas Soft ExtraBold', sans-serif;
    font-style: normal;
    font-size: 24px;
    line-height: 30px;
    padding: 6px 0px;
    word-break: break-word;
}

.tab > p {
    margin: 0;
    word-break: break-word;
}

@media (min-width: 768px) {
    .tab:not(:last-child) {
        border-right: 2px solid #FFFFFF;
    }
}

.feature:nth-child(even) {
    background-color: #E7F3EC;
}

.feature:nth-child(even) > td:not(:last-child) {
    border-right: 2px solid #FFFFFF;
}

.feature:nth-child(odd) > td:not(:last-child) {
    border-right: 2px solid #E7F3EC;
}

.cell-text >>> p {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #2A514D;
    margin: 0;
}

.cell-text {
    padding: 8px 10px;
    word-break: break-word;
}

td {
    text-align: center;
    vertical-align: middle;
    height: 36px;
}

td > img {
    margin-top: 8px;
    margin-bottom: 8px;
}

.category-header-title, .feature-title {
    padding: 8px 20px 8px 12px;
    text-align: left;
}

.feature-title >>> * {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #2A514D;
    margin: 0;
    word-break: break-word;
}

.category-header-title >>> * {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #1F5134;
    margin: 0;
    word-break: break-word;
}

.category-header-title {
    min-height: 48px;
}

.category-header {
    background-color: #C5E1D0;
}

.category-header > td {
    background-color: #C5E1D0;
}

.column-marker {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    word-break: break-word;

    color: #2A514D;

    background: #E5FE46;
    border: 2px solid #FFFFFF;
    border-radius: 0px 22px 0px 0px;
}

@media (max-width: 767px) {
    .tab {
        display: flex;
        flex-direction: column;
        border-radius: 0px 38px 0px 0px;
        padding: 9px 0 0 0;
        margin-bottom: 5px;
        position: relative;
    }

    .tab > span {
        font-size: 32px;
        line-height: 120%;
        letter-spacing: -0.02em;
        word-break: break-word;
    }

    .tab > p {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 17px;
        line-height: 27px;
        word-break: break-word;
    }

    .tab.vc-collapse.expanded img.plus-circle {
        display: none;
    }

    .tab.vc-collapse.expanded .information-button {
        background-color: #A1CDB3;
    }

    .tab.vc-collapse:not(.expanded) img.minus-circle {
        display: none;
    }

    .v-collapse-content.v-collapse-content-end {
        max-height: fit-content;
    }

    .feature {
        display: flex;
    }

    .feature-title {
        width: 60%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 8px 20px 8px 12px;
        word-break: break-word;
    }

    .feature:nth-child(even) {
        background-color: #E7F3EC;
    }

    .feature:nth-child(even) > .feature-title {
        border-right: 2px solid #FFFFFF;
    }

    .feature:nth-child(odd) {
        background-color: #FFFFFF;
    }

    .feature:nth-child(odd) > div {
        background-color: #FFFFFF;
    }

    .feature:nth-child(odd) > .feature-title {
        border-right: 2px solid #E7F3EC;
    }

    .category-header-title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 60%;
        word-break: break-word;
        padding: 8px 20px 8px 12px;
    }

    .cell-text {
        width: 40%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 10px;
        word-break: break-word;
    }

    .cell-icon {
        width: 40%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 0px;
    }

    .information-button {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
        color: #FFFFFF;
        background: #2A514D;
        border-radius: 8px;
        margin: 15px 50px 20px 50px;
        padding: 9px 10px 9px 10px;
        border: unset;
        word-break: break-word;
    }

    .information-button > p {
        margin: 0px 17px 0px 0px;
    }

    .marker-mobile {
        height: 70px;
        padding-top: 5px;
        background-color: #E5FE46;
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        word-break: break-word;
        color: #2A514D;
        position: absolute;
        top: -30px;
        width: 100%;
        z-index: -1;
    }

    .tab.marker {
        margin-top: 35px;
    }

    .collapse-content-container, .categories, .features {
        background-color: #FFFFFF;
    }
}
</style>